import { render, staticRenderFns } from "./activityCustomer.vue?vue&type=template&id=b5d06cbe&scoped=true&"
import script from "./activityCustomer.vue?vue&type=script&lang=ts&"
export * from "./activityCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./activityCustomer.vue?vue&type=style&index=0&id=b5d06cbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d06cbe",
  null
  
)

export default component.exports